export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  categorySlug: string;
  categoryName: string;
  author: string;
  date: string;
  coverImage: string;
  tags: string[];
  readTime: string;
}

export type ArticleSummary = Pick<Article, "id" | "title" | "excerpt" | "categorySlug" | "categoryName" | "author" | "date" | "coverImage" | "tags" | "readTime">;

export const articles: Article[] = [
  {
    id: "2024-sheji-qushi",
    title: "2024年平面设计趋势：极简主义回归与色彩革命",
    excerpt: "探索2024年最炙手可热的平面设计趋势，从极简主义回潮到大胆配色，带你抢先了解行业风向标。",
    content: `<p>2024年，平面设计领域正在经历一场深刻的变革。在经历了过去几年复杂视觉效果与3D渲染的热潮之后，极简主义以全新的面貌强势回归。这不是简单的"少即是多"，而是一种经过深思熟虑的设计哲学。</p>

<h2>极简主义2.0：不只是减法</h2>
<p>新一代极简主义不再仅仅是去除多余元素。它强调<strong>功能性</strong>与<strong>美学</strong>的完美平衡。设计师们开始更多地关注留白的力量，通过<strong>黄油网站</strong>的智能排版工具，即使是新手也能轻松掌握高级留白技巧。</p>

<p>关键特征包括：大面积的留白空间、克制的色彩运用、以及精心挑选的字体组合。这种风格特别适合品牌VI设计和高端产品展示。</p>

<h2>色彩革命：复古未来主义</h2>
<p>与此同时，复古未来主义配色方案正在席卷设计界。鲜艳的霓虹色与柔和的复古色调相结合，创造出既熟悉又陌生的视觉体验。黄油网站素材库已全面更新这类配色方案，供创作者自由调用。</p>

<p>色彩搭配不再是设计师的专利。黄油网站的智能配色功能可以根据你的品牌调性一键生成配色方案，让你不再为选色而苦恼。</p>

<h2>动态排版：让文字活起来</h2>
<p>文字不再只是信息的载体，它本身就是设计的主角。动态排版技术让标题文字充满动感和张力，配合黄油网站的图文制作工具，你可以轻松创建引人注目的排版效果。</p>

<p>无论是海报设计还是社交媒体图片，动态排版都能让你的作品在海量信息中脱颖而出。</p>

<h2>可持续发展设计</h2>
<p>环保意识已经渗透到设计领域。越来越多的品牌选择使用自然色调、可回收材料质感的设计语言。这种趋势不仅体现了品牌的社会责任感，也赢得了消费者的好感。</p>`,
    categorySlug: "chuangyi-sheji",
    categoryName: "创意设计",
    author: "设计部 · 小麦",
    date: "2024-12-18",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20graphic%20design%20workspace%20with%20color%20palette%20swatches%20and%20typography%20samples%20on%20clean%20white%20desk%2C%20natural%20warm%20lighting%2C%20artistic%20composition%2C%20editorial%20style%20photography%20with%20soft%20shadows%20and%20elegant%20aesthetic&width=800&height=450&seq=article-trend-01&orientation=landscape",
    tags: ["设计趋势", "极简主义", "配色方案", "排版设计"],
    readTime: "8分钟",
  },
  {
    id: "shejiao-meiti-muban",
    title: "10款小红书爆款封面模板，让你的笔记点击率翻倍",
    excerpt: "精选10款经过数据验证的高点击率封面模板，涵盖美妆、美食、穿搭、旅行等热门领域。",
    content: `<p>在小红书平台，一张精美的封面图往往是决定笔记命运的<strong>关键因素</strong>。根据平台数据分析，优质封面图可以将笔记点击率提升<strong>200%以上</strong>。今天，我们用黄油网站为大家整理了10款经过实战验证的爆款封面模板。</p>

<h2>为什么封面如此重要？</h2>
<p>在信息流中，用户平均只花<strong>0.3秒</strong>来决定是否点击一篇笔记。这个极短的决策时间里，封面图几乎决定了全部。黄油网站的图文制作工具专为这一场景优化，让你的封面制作效率提升5倍。</p>

<h2>10款爆款模板解析</h2>

<h3>1. 大字标题型</h3>
<p>适合观点类、干货类内容。大字标题直接点明主题，配合简洁背景，视觉冲击力极强。在黄油网站中，你可以在模板素材库中找到近百款大字标题模板。</p>

<h3>2. 对比展示型</h3>
<p>适合美妆、穿搭、家居改造类内容。左右或上下对比的布局方式，让变化一目了然。黄油网站的左右拼接功能可以一键实现。</p>

<h3>3. 步骤拆解型</h3>
<p>适合教程类内容。用数字标注步骤，配合简洁图示，让复杂的教程变得清晰易懂。</p>

<h3>4. 清单汇总型</h3>
<p>适合好物推荐、攻略总结类内容。"必买清单""旅行攻略"等标题配合整齐排列的商品或景点图片。</p>

<h3>5. 情感共鸣型</h3>
<p>适合生活方式、情感类内容。温馨的场景图片配合走心的文案，引发用户情感共鸣。</p>

<p>以上模板均可在黄油网站模板库中直接下载使用，支持一键替换文字和图片，3分钟即可完成一张高质量封面。</p>`,
    categorySlug: "muban-sucai",
    categoryName: "模板素材",
    author: "运营部 · 小鱼",
    date: "2024-12-12",
    coverImage: "https://readdy.ai/api/search-image?query=Creative%20social%20media%20cover%20templates%20displayed%20on%20minimal%20white%20desk%20with%20smartphone%20showcasing%20beautiful%20layouts%2C%20warm%20natural%20light%2C%20artistic%20flat%20lay%20photography%20with%20pastel%20color%20accents&width=800&height=450&seq=article-social-02&orientation=landscape",
    tags: ["小红书", "封面模板", "社交媒体", "点击率"],
    readTime: "6分钟",
  },
  {
    id: "chuxuezhe-rumen",
    title: "黄油网站新手完全指南：从注册到出图只需10分钟",
    excerpt: "超详细的新手入门教程，手把手带你了解黄油网站的全部核心功能，让你快速上手创作。",
    content: `<p>欢迎来到<strong>黄油网站</strong>！如果你刚刚注册，不知从何下手，这篇完全指南就是为你准备的。我们将用最简单直白的方式，带你走完从零到一的创作之旅。</p>

<h2>第一步：注册与基础设置</h2>
<p>打开黄油网站官方入口，使用邮箱或手机号注册账号。注册后建议先完善个人资料，包括头像、昵称和个人简介，这有助于建立你在社区中的个人品牌。</p>

<h2>第二步：认识工作台</h2>
<p>黄油网站的工作台设计简洁直观。左侧是功能导航栏，中间是编辑区域，右侧是属性面板。初次使用时，建议先花2分钟熟悉各个功能模块的位置。</p>

<p><strong>核心功能区</strong>包括：模板中心、素材库、文字工具、图片编辑、背景设置、导出功能。</p>

<h2>第三步：选择模板开始创作</h2>
<p>点击模板中心，你可以按照用途（海报、封面、长图等）和风格（简约、复古、清新等）筛选模板。选中喜欢的模板后点击"使用"，即可进入编辑器开始创作。</p>

<h2>第四步：编辑与定制</h2>
<p>进入编辑器后，你可以：</p>
<ul>
<li>双击文字区域修改文案内容</li>
<li>点击图片区域替换为自己的图片或从素材库选择</li>
<li>使用右侧面板调整颜色、字体、大小等参数</li>
<li>拖拽元素调整位置和层级关系</li>
</ul>

<h2>第五步：导出与分享</h2>
<p>完成设计后，点击右上角的导出按钮，选择需要的格式和分辨率。黄油网站支持PNG、JPG、PDF等多种格式导出。导出的作品可以直接分享到社交媒体平台。</p>

<p>恭喜你！现在你已经掌握了黄油网站的基础使用方法。接下来就是多多练习，不断探索更多高级功能。教程中心还有更多深度内容等你发掘。</p>`,
    categorySlug: "shiyong-jiaocheng",
    categoryName: "使用教程",
    author: "产品部 · 小白",
    date: "2024-12-05",
    coverImage: "https://readdy.ai/api/search-image?query=Clean%20minimal%20desk%20setup%20with%20laptop%20showing%20design%20software%20interface%2C%20warm%20coffee%20cup%20beside%20keyboard%2C%20soft%20natural%20light%20from%20window%2C%20cozy%20creative%20workspace%20atmosphere%2C%20top%20down%20view&width=800&height=450&seq=article-beginner-03&orientation=landscape",
    tags: ["新手教程", "入门指南", "注册使用", "快速上手"],
    readTime: "10分钟",
  },
  {
    id: "gaoji-paiban-jiqiao",
    title: "高级排版技巧：让普通文字变得高级的7个秘诀",
    excerpt: "学会这些专业排版技巧，你的设计作品将脱胎换骨。从字体选择到行距调整，细节决定品质。",
    content: `<p>排版是设计中最基础也最难掌握的部分。为什么同样的文字内容，专业设计师排出来就是更高级？答案就在细节里。今天借助<strong>黄油网站</strong>的图文制作功能，分享7个让文字排版瞬间提升的高级技巧。</p>

<h2>1. 字间距的艺术</h2>
<p>标题文字适当增加字间距（+5%~+15%），可以营造呼吸感和高级感。但正文不适宜过大字间距，否则会影响阅读流畅性。在黄油网站中，你可以通过字间距滑块精确调整。</p>

<h2>2. 行高的黄金比例</h2>
<p>正文行高设置为字号的<strong>1.5-1.8倍</strong>是最佳阅读体验区间。标题行高则应该更紧凑，约为字号的1.1-1.3倍。</p>

<h2>3. 对比创造层次</h2>
<p>通过字号、字重、颜色的对比来建立信息层级。一个页面中通常需要3-4个不同的层级：主标题、副标题、正文、注释文字。</p>

<h2>4. 对齐的力量</h2>
<p>左对齐是最安全的选择，适合大多数场景。居中对齐适合短文案和标题。两端对齐需要谨慎使用，避免出现文字间距不均匀的情况。</p>

<h2>5. 留白即呼吸</h2>
<p>设计师中最常见的错误就是害怕留白。足够的留白让内容有呼吸空间，让读者的眼睛得到休息。黄油网站的智能留白功能可以帮助你自动优化版面间距。</p>

<h2>6. 颜色的克制</h2>
<p>正文颜色避免使用纯黑(#000000)，改用深灰(#333333或#444444)会让阅读体验更舒适。一个设计中正文的颜色变化不宜超过3种。</p>

<h2>7. 字体搭配法则</h2>
<p>一个设计中最多使用2-3种字体。标题用有特色的展示字体，正文用易读的无衬线字体，这是最经典的搭配方案。</p>`,
    categorySlug: "tuwen-zhizuo",
    categoryName: "图文制作",
    author: "设计部 · 老K",
    date: "2024-11-28",
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20typography%20design%20samples%20laid%20out%20on%20minimal%20white%20surface%20with%20various%20font%20styles%20and%20sizes%2C%20warm%20ambient%20light%2C%20editorial%20design%20aesthetic%2C%20clean%20composition%20with%20soft%20shadows&width=800&height=450&seq=article-typography-04&orientation=landscape",
    tags: ["排版技巧", "字体设计", "设计教程", "高级排版"],
    readTime: "7分钟",
  },
  {
    id: "2025-secai-dapei",
    title: "2025年度流行色预测与搭配指南",
    excerpt: "提前锁定2025年最可能流行的配色方案，从Pantone预测到实际应用，一网打尽。",
    content: `<p>每到年末，设计圈最令人期待的话题之一就是来年的流行色预测。作为创意设计领域的先行者，<strong>黄油网站</strong>结合全球色彩机构的预测和市场趋势，为大家整理了2025年度最值得关注的配色方向。</p>

<h2>温暖大地色系持续走强</h2>
<p>从2024年延续至今的大地色系热度不减。陶土色、沙色、橄榄绿等自然色调继续主导设计配色。这类颜色传递温暖、可靠、环保的品牌形象，特别适合生活方式和可持续发展品牌。</p>

<h2>数字薰衣草：2025年度色</h2>
<p>多个色彩机构不约而同地将目光投向紫色系。数字薰衣草（Digital Lavender）被认为将是2025年的标志性色彩。这种柔和的紫色调既保留了科技感，又传递了宁静与治愈的情绪。</p>

<h2>高饱和撞色回潮</h2>
<p>在极简风盛行的背景下，大胆的撞色搭配成为设计师表达个性的利器。电光蓝搭配火焰橙、柠檬黄碰撞紫罗兰，这种高对比度的配色方式在社交媒体内容中尤为出彩。</p>

<p>黄油网站的配色工具已经内置了2025年度流行色方案，你可以直接在模板中调用这些最新配色，让你的设计始终走在潮流前沿。</p>`,
    categorySlug: "sheji-linggan",
    categoryName: "设计灵感",
    author: "设计部 · Color哥",
    date: "2024-11-20",
    coverImage: "https://readdy.ai/api/search-image?query=Beautiful%20color%20palette%20swatches%20arranged%20artistically%20on%20warm%20cream%20background%20with%20paint%20chips%20and%20fabric%20samples%2C%20soft%20natural%20lighting%2C%20minimal%20elegant%20composition%2C%20design%20studio%20aesthetic&width=800&height=450&seq=article-color-05&orientation=landscape",
    tags: ["配色方案", "流行色", "2025趋势", "设计色彩"],
    readTime: "5分钟",
  },
  {
    id: "mianfei-sucai-wangzhan",
    title: "这8个免费高清素材网站，设计师都在偷偷收藏",
    excerpt: "盘点8个高质量免费素材资源网站，涵盖图片、插画、图标、字体等，解决你的素材焦虑。",
    content: `<p>做设计最怕的就是"素材荒"。找不到合适的图片、买不起昂贵的商业图库，这些问题困扰着无数创作者。今天，<strong>黄油网站</strong>为大家整理了8个真正好用且免费的素材资源网站。当然，黄油网站自带的素材库本身就是一个宝藏。</p>

<h2>1. 黄油网站素材库（首推）</h2>
<p>为什么要舍近求远？黄油网站内置的素材库已经涵盖了数百万张高质量图片、插画、字体和图标。所有素材均已获得商业使用授权，无需担心版权问题。最重要的是，在黄油网站内直接使用，无需下载上传，效率提升显著。</p>

<h2>2. Unsplash</h2>
<p>全球最大的免费高清图片网站，图片质量极高。适合需要真实场景照片的设计项目。</p>

<h2>3. Pexels</h2>
<p>与Unsplash类似的免费图片和视频素材平台，内容更加多元化。</p>

<h2>4. Pixabay</h2>
<p>包含图片、插画、矢量图和视频的综合素材平台，数量庞大。</p>

<h2>5. unDraw</h2>
<p>开源的插画素材库，所有插画风格统一，可以自定义配色，非常适合网页和应用界面设计。</p>

<h2>6. Google Fonts</h2>
<p>最权威的免费字体库，黄油网站已全面接入Google Fonts，你可以在编辑器中直接使用上千款优质字体。</p>

<h2>7. Flaticon</h2>
<p>海量免费图标资源，支持SVG格式下载，可以自由调整大小和颜色。</p>

<h2>8. Humaaans</h2>
<p>专注于人物插画的素材库，风格现代、多样化，可以自由组合人物姿态和场景。</p>

<p>以上所有素材网站均支持免费商用，但建议使用前确认具体图片的授权条款。而黄油网站素材库的所有内容均已100%确认商业授权，使用更放心。</p>`,
    categorySlug: "sucaiku",
    categoryName: "素材库",
    author: "编辑部 · 阿元",
    date: "2024-11-15",
    coverImage: "https://readdy.ai/api/search-image?query=Organized%20creative%20resource%20collection%20displayed%20on%20clean%20desk%20with%20colorful%20image%20cards%20and%20design%20elements%2C%20warm%20morning%20light%2C%20artistic%20flat%20lay%20photography%20with%20soft%20pastel%20tones&width=800&height=450&seq=article-resources-06&orientation=landscape",
    tags: ["免费素材", "素材网站", "设计资源", "版权素材"],
    readTime: "6分钟",
  },
  {
    id: "pingpai-sheji-zhinan",
    title: "小品牌大设计：零预算打造高级品牌视觉系统",
    excerpt: "预算有限也能做出好设计？当然！分享一套零成本品牌视觉设计方法论。",
    content: `<p>很多创业者和小品牌主认为，打造高级的品牌视觉系统需要大量资金投入。实际上，借助<strong>黄油网站</strong>这样的工具平台，零预算也能做出专业级的品牌设计。</p>

<h2>品牌视觉的核心要素</h2>
<p>一个完整的品牌视觉系统包含：Logo、色彩体系、字体系统、辅助图形、应用规范。听起来复杂，但在黄油网站的模板素材库中，你已经可以找到数百套完整的品牌VI模板。</p>

<h2>Logo设计：简单即是高级</h2>
<p>对于小品牌来说，纯文字Logo或极简图形Logo是最佳选择。在黄油网站的创意设计模块中，你可以找到大量极简Logo模板，只需替换品牌名称即可使用。</p>

<h2>色彩体系：3色法则</h2>
<p>小品牌不需要复杂的配色方案。一个主色+一个辅助色+一个中性色，就足以构建完整的品牌色彩体系。黄油网站的配色工具可以帮助你基于这三个颜色自动生成完整的色阶。</p>

<h2>字体系统：少即是多</h2>
<p>选择一款有特色的标题字体和一款易读的正文字体，就可以满足90%的品牌应用场景。</p>

<h2>模板化应用</h2>
<p>品牌视觉的最终目的是应用。黄油网站提供从名片、信纸、PPT模板到社交媒体全套模板，你只需要在这些模板上应用你的品牌元素，就能快速建立统一的品牌形象。</p>`,
    categorySlug: "chuangyi-sheji",
    categoryName: "创意设计",
    author: "品牌部 · Nina",
    date: "2024-11-08",
    coverImage: "https://readdy.ai/api/search-image?query=Minimal%20brand%20identity%20design%20kit%20with%20business%20cards%20letterhead%20and%20envelope%20arranged%20on%20clean%20white%20marble%20surface%2C%20warm%20natural%20light%2C%20elegant%20professional%20aesthetic%2C%20top%20down%20view&width=800&height=450&seq=article-branding-07&orientation=landscape",
    tags: ["品牌设计", "VI系统", "零预算", "品牌视觉"],
    readTime: "7分钟",
  },
  {
    id: "shipin-fengmian-sheji",
    title: "视频封面的设计密码：为什么有些封面让人忍不住点击？",
    excerpt: "揭秘高点击率视频封面的设计规律，从色彩心理学到构图技巧，全面提升你的封面设计能力。",
    content: `<p>在这个短视频称王的时代，视频封面图比以往任何时候都更加重要。一个精心设计的封面可以让视频播放量提升数倍。那么，那些让人忍不住点击的封面图到底有什么秘密？</p>

<h2>心理学原理：好奇心缺口</h2>
<p>人类天生对不完整的信息感到好奇。优秀的封面设计会巧妙利用这一点——展示足够吸引人的信息，但又保留一些悬念。例如使用"你绝对想不到""99%的人都不知道"等文案配合引人好奇的画面。</p>

<h2>色彩策略：高对比+暖色调</h2>
<p>数据表明，使用高对比度色彩搭配的封面图点击率明显高于柔和配色。特别是<strong>黄色、橙色、红色</strong>等暖色调，在信息流中具有更强的视觉穿透力。在黄油网站的图文制作模块中，你可以一键应用这些高点击率的配色方案。</p>

<h2>构图法则：三分法与视觉焦点</h2>
<p>无论画面多么复杂，必须有一个清晰的视觉焦点。人物面部表情、产品特写、或者是醒目的文字标题——选择一个元素作为主角，让其他元素为它服务。</p>

<h2>文字的力量</h2>
<p>封面上的文字需要遵循3秒原则：用户需要在3秒内读完并理解。因此，标题文字不宜超过8个字，辅助文字不超过15个字。字体选择上，粗体无衬线字体的表现最佳。</p>

<p>黄油网站的模板素材库中提供了大量经过数据验证的高点击封面模板，涵盖知识类、娱乐类、美食类、美妆类等各个领域。</p>`,
    categorySlug: "tuwen-zhizuo",
    categoryName: "图文制作",
    author: "编辑部 · 大鹏",
    date: "2024-10-28",
    coverImage: "https://readdy.ai/api/search-image?query=Collection%20of%20eye%20catching%20video%20thumbnail%20designs%20on%20computer%20screen%20with%20bold%20colors%20and%20text%20overlays%2C%20modern%20content%20creator%20workspace%20with%20warm%20lighting%2C%20editorial%20style&width=800&height=450&seq=article-thumbnail-08&orientation=landscape",
    tags: ["视频封面", "点击率", "封面设计", "视觉心理学"],
    readTime: "6分钟",
  },
  {
    id: "AI-sheji-gongju",
    title: "AI设计工具大盘点：2024年最值得尝试的AI创作助手",
    excerpt: "AI正在重塑设计行业。从AI生图到智能排版，盘点2024年最实用的AI设计工具。",
    content: `<p>2024年，AI已从概念走向应用，深刻改变着创意设计行业的工作方式。<strong>黄油网站</strong>也在积极融入AI技术，为创作者提供更智能的设计体验。</p>

<h2>AI在设计中扮演什么角色？</h2>
<p>AI不是来取代设计师的，而是设计师的超级助手。它可以处理重复性工作、提供创意灵感、加速设计流程。真正优秀的作品，仍然需要人类设计师的审美判断和创意决策。</p>

<h2>黄油网站的AI功能</h2>
<p>作为创意设计平台，黄油网站已经整合了多项AI能力：</p>
<ul>
<li><strong>AI智能配色</strong>：上传一张参考图片，AI自动提取配色方案</li>
<li><strong>AI文案生成</strong>：输入关键词，自动生成多种风格的文案</li>
<li><strong>AI背景移除</strong>：一键去除图片背景，精度超越传统工具</li>
<li><strong>智能排版建议</strong>：AI分析内容后推荐最优排版方案</li>
</ul>

<h2>其他值得关注的AI设计工具</h2>
<p>除了黄油网站，行业内还有Midjourney、DALL·E等AI图像生成工具，以及各类AI辅助设计插件。建议设计师保持开放心态，积极学习和尝试这些新工具。</p>

<p>记住：工具在变，但设计的本质不变——解决问题、传递信息、创造美感。掌握AI工具可以让你变得更高效，但创意和审美才是你的核心竞争力。</p>`,
    categorySlug: "sheji-linggan",
    categoryName: "设计灵感",
    author: "技术部 · Leo",
    date: "2024-10-15",
    coverImage: "https://readdy.ai/api/search-image?query=Futuristic%20AI%20design%20workspace%20with%20holographic%20interface%20and%20digital%20art%20tools%20displayed%20on%20sleek%20screen%2C%20minimal%20modern%20studio%20with%20warm%20ambient%20lighting%2C%20clean%20tech%20aesthetic&width=800&height=450&seq=article-ai-09&orientation=landscape",
    tags: ["AI设计", "智能工具", "设计效率", "科技趋势"],
    readTime: "5分钟",
  },
];